/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import node_logImg from 'assets/images/node-log.png'
import node_runImg from 'assets/images/node-run.png'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Node.js</h2>
    <p className={styles.description}>
      <b>Node.js</b> — легкая и эффективная среда выполнения JavaScript. Позволяет писать высокопроизводительные
      серверные приложения и инструменты. Node.js построен на JavaScript-движке V8 и написан на C++, поэтому он быстрый.{' '}
    </p>
    <p className={styles.description}>
      Изначально Node.js создавался как серверное окружение для приложений, но разработчики начали использовать его для
      создания инструментов, помогающих автоматизировать выполнение локальных задач. В итоге возникшая вокруг Node.js
      новая экосистема инструментов (вроде Grunt и Gulp), привела к трансформации процесса фронтенд-разработки.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - Установка</h3>
      <p className={styles.description}>
        Чтобы установить последнюю версию перейдите на{' '}
        <a className={styles.link} rel="noopener noreferrer" href="https://nodejs.org/en/" target="_blank">
          официальную страницу
        </a>
        , скачайте инсталятор и следуйте указаниям, достаточно просто нажимать <code className={styles.code}>Next</code>
        . Есть установщики для Windows и MacOS, а также скомпилированные бинарники и исходный код для Linux.{' '}
      </p>
      <p className={styles.description}>
        После установки, в терминале будет доступна команда <code className={styles.code}>node</code>. Для того чтобы
        убедиться что установка прошла успешно, проверьте версию, запустив в консоли команду{' '}
        <code className={styles.code}>node</code> с флагом <code className={styles.code}>version</code>.
      </p>
      <CopyBlock text={`node --version`} language="javascript" showLineNumbers={false} theme={ocean} />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.2 - Основы Node.js</h3>
      <p className={styles.description}>
        Node.js позвляет выполнять JavaScript-код без браузера. Откройте любой терминал, и выполните команду{' '}
        <code className={styles.code}>node</code>, запустится{' '}
        <a className={styles.link} rel="noopener noreferrer" href="https://ru.wikipedia.org/wiki/REPL" target="_blank">
          REPL{' '}
        </a>
        — интерактивная среда выполнения JS-кода. Выведем что-то в консоль.
      </p>
      <img className={styles.img} src={node_logImg} alt="node-log" />
      <p className={styles.notificationInfo}>
        Для того чтобы выйти из REPL, два раза нажмите комбинацию <code className={styles.code}>Ctrl+C</code>.{' '}
      </p>
      <p className={styles.description}>
        Теперь создадим папку <code className={styles.code}>node-tut</code>, а в ней файл{' '}
        <code className={styles.code}>index.js</code> с кодом который мы писали в <b>REPL</b>. Для запуска нужно открыть
        терминал и перейти в папку <code className={styles.code}>node-tut</code>, в которой лежит{' '}
        <code className={styles.code}>index.js</code>.{' '}
      </p>
      <CopyBlock
        text={`// index.js
const message = 'Node.js in amazing!';
console.log(message);`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <p className={styles.description}>
        Теперь в консоли запускаем файл с помощью команды <code className={styles.code}>node index.js</code>. Получаем
        тот же результат — вывод строки непосредственно в терминале.
      </p>
      <img className={styles.img} src={node_runImg} alt="node-run" />

      <p className={styles.description}>
        В этом и заключается суть Node.js - возможность выполнять JavaScript вне браузера. Таким образом можно писать
        целые приложения, к примеру бекенд или инструменты не зависящие от браузера.{' '}
      </p>
    </section>
  </section>
))
